import { render, staticRenderFns } from "./IndexCategory.vue?vue&type=template&id=b668f2b4&scoped=true&"
import script from "./IndexCategory.vue?vue&type=script&lang=js&"
export * from "./IndexCategory.vue?vue&type=script&lang=js&"
import style0 from "./IndexCategory.vue?vue&type=style&index=0&id=b668f2b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b668f2b4",
  null
  
)

export default component.exports